/* SECOYA — scripts propios. Sin librerías. */
(function () {
  if (window.__syIniciado) return;
  window.__syIniciado = true;

  var reducido = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var enEditor = !!(window.Shopify && window.Shopify.designMode);
  var ratonFino = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  var observador = null;
  var alVer = []; // [{el, fn}] acciones que se disparan una vez al entrar en pantalla

  /* ---------- Entradas al hacer scroll ---------- */
  function marcarVisible(el) {
    el.classList.add('sy-visible');
    for (var i = alVer.length - 1; i >= 0; i--) {
      if (alVer[i].el === el) { alVer[i].fn(); alVer.splice(i, 1); }
    }
    // Tras la entrada, soltamos la clase para que hovers e inclinación funcionen
    if (el.classList.contains('sy-reveal') && !el.classList.contains('sy-partido')) {
      setTimeout(function () { el.classList.remove('sy-reveal'); }, 1900);
    }
  }

  function observar(els) {
    if (!els.length) return;
    if (reducido || enEditor || !('IntersectionObserver' in window)) {
      els.forEach(marcarVisible);
      return;
    }
    if (!observador) {
      observador = new IntersectionObserver(function (entradas) {
        entradas.forEach(function (e) {
          if (e.isIntersecting) { marcarVisible(e.target); observador.unobserve(e.target); }
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
    }
    els.forEach(function (el) { observador.observe(el); });
  }

  /* ---------- Títulos palabra a palabra ---------- */
  function partir(nodo, contador) {
    Array.prototype.slice.call(nodo.childNodes).forEach(function (hijo) {
      if (hijo.nodeType === 3) {
        var trozos = hijo.textContent.split(/(\s+)/);
        var frag = document.createDocumentFragment();
        trozos.forEach(function (t) {
          if (!t) return;
          if (/^\s+$/.test(t)) { frag.appendChild(document.createTextNode(' ')); return; }
          var fuera = document.createElement('span');
          fuera.className = 'sy-palabra';
          var dentro = document.createElement('span');
          dentro.style.setProperty('--w', contador.n++);
          dentro.textContent = t;
          fuera.appendChild(dentro);
          frag.appendChild(fuera);
        });
        nodo.replaceChild(frag, hijo);
      } else if (hijo.nodeType === 1 && hijo.tagName !== 'BR') {
        partir(hijo, contador);
      }
    });
  }

  function initTitulos(raiz) {
    if (reducido || enEditor) return;
    raiz.querySelectorAll('.sy-h1.sy-reveal:not(.sy-partido), .sy-h2.sy-reveal:not(.sy-partido)').forEach(function (h) {
      h.setAttribute('aria-label', h.textContent.replace(/\s+/g, ' ').trim());
      partir(h, { n: 0 });
      h.classList.add('sy-partido');
    });
  }

  /* ---------- Barra de progreso + parallax ---------- */
  var barraProgreso = null;
  var conParallax = [];
  var enCola = false;

  function alDesplazar() {
    enCola = false;
    var alto = document.documentElement.scrollHeight - window.innerHeight;
    if (barraProgreso) barraProgreso.style.setProperty('--sy-avance', alto > 0 ? Math.min(1, window.scrollY / alto) : 0);
    var vh = window.innerHeight;
    conParallax.forEach(function (p) {
      var r = p.el.getBoundingClientRect();
      if (r.bottom < -200 || r.top > vh + 200) return;
      var centro = r.top + r.height / 2 - vh / 2;
      p.el.style.setProperty('--sy-py', (centro * p.f * -1).toFixed(1) + 'px');
    });
  }
  function pedirCuadro() { if (!enCola) { enCola = true; requestAnimationFrame(alDesplazar); } }

  function initScroll(raiz) {
    if (reducido || enEditor) return;
    if (!barraProgreso) {
      barraProgreso = document.createElement('div');
      barraProgreso.className = 'sy-progreso';
      barraProgreso.setAttribute('aria-hidden', 'true');
      document.body.appendChild(barraProgreso);
      window.addEventListener('scroll', pedirCuadro, { passive: true });
      window.addEventListener('resize', pedirCuadro);
    }
    raiz.querySelectorAll('[data-sy-parallax]').forEach(function (el) {
      if (el.dataset.syListo) return;
      el.dataset.syListo = '1';
      conParallax.push({ el: el, f: parseFloat(el.dataset.syParallax) || 0.1 });
    });
    pedirCuadro();
  }

  /* ---------- Tarjetas que se inclinan ---------- */
  function initInclinacion(raiz) {
    if (reducido || enEditor || !ratonFino) return;
    raiz.querySelectorAll('.sy-tarjeta, .sy-detalle__item').forEach(function (t) {
      if (t.dataset.syInclina) return;
      t.dataset.syInclina = '1';
      t.classList.add('sy-inclina');
      t.addEventListener('pointermove', function (e) {
        var r = t.getBoundingClientRect();
        var x = (e.clientX - r.left) / r.width - 0.5;
        var y = (e.clientY - r.top) / r.height - 0.5;
        t.classList.add('is-moviendo');
        t.style.setProperty('--ry', (x * 7).toFixed(2) + 'deg');
        t.style.setProperty('--rx', (y * -7).toFixed(2) + 'deg');
      });
      t.addEventListener('pointerleave', function () {
        t.classList.remove('is-moviendo');
        t.style.setProperty('--ry', '0deg');
        t.style.setProperty('--rx', '0deg');
      });
    });
  }

  /* ---------- Comparador antes/después ---------- */
  function initComparadores(raiz) {
    raiz.querySelectorAll('.sy-comparador').forEach(function (c) {
      if (c.dataset.syListo) return;
      c.dataset.syListo = '1';
      var rango = c.querySelector('input[type="range"]');
      if (!rango) return;
      var tocado = false;
      var pintar = function () { c.style.setProperty('--pos', rango.value + '%'); };
      rango.addEventListener('input', function () { tocado = true; pintar(); });
      rango.addEventListener('pointerdown', function () { tocado = true; });
      pintar();
      if (reducido || enEditor) return;
      // Al entrar en pantalla se mueve solo una vez para invitar a tocarlo
      alVer.push({ el: c, fn: function () {
        var inicio = parseFloat(rango.value);
        var ruta = [inicio, 24, 74, inicio];
        var dur = 2600, t0 = null;
        var suave = function (x) { return x < 0.5 ? 2 * x * x : 1 - Math.pow(-2 * x + 2, 2) / 2; };
        var paso = function (t) {
          if (tocado) return;
          if (t0 === null) t0 = t;
          var p = Math.min(1, (t - t0) / dur) * (ruta.length - 1);
          var i = Math.min(ruta.length - 2, Math.floor(p));
          var v = ruta[i] + (ruta[i + 1] - ruta[i]) * suave(p - i);
          rango.value = v;
          c.style.setProperty('--pos', v + '%');
          if (p < ruta.length - 1) requestAnimationFrame(paso);
        };
        setTimeout(function () { requestAnimationFrame(paso); }, 700);
      } });
    });
  }

  /* ---------- Cifras que cuentan ---------- */
  function initCifras(raiz) {
    raiz.querySelectorAll('[data-sy-cifra]').forEach(function (el) {
      if (el.dataset.syListo) return;
      el.dataset.syListo = '1';
      var texto = (el.dataset.syCifra || '').trim();
      var m = texto.match(/^(\d+)(?:[.,](\d+))?$/);
      if (!m || reducido || enEditor) { el.textContent = texto; return; }
      var decimales = m[2] ? m[2].length : 0;
      var coma = texto.indexOf(',') > -1;
      var final = parseFloat(texto.replace(',', '.'));
      var pintar = function (v) {
        var s = v.toFixed(decimales);
        el.textContent = coma ? s.replace('.', ',') : s;
      };
      pintar(0);
      var contenedor = el.closest('.sy-reveal, .sy-visible') || el;
      var lanzar = function () {
        var dur = 1800, t0 = null;
        var paso = function (t) {
          if (t0 === null) t0 = t;
          var p = Math.min(1, (t - t0) / dur);
          pintar(final * (1 - Math.pow(1 - p, 4)));
          if (p < 1) requestAnimationFrame(paso); else pintar(final);
        };
        requestAnimationFrame(paso);
      };
      if (contenedor.classList.contains('sy-visible')) lanzar(); else alVer.push({ el: contenedor, fn: lanzar });
    });
  }

  /* ---------- Elige tu color ---------- */
  function initColores(raiz) {
    raiz.querySelectorAll('[data-sy-colores]').forEach(function (sec) {
      if (sec.dataset.syListo) return;
      sec.dataset.syListo = '1';
      var chips = sec.querySelectorAll('.sy-chip');
      var fotos = sec.querySelectorAll('.sy-colores__foto');
      var nombre = sec.querySelector('[data-sy-color-nombre]');
      var boton = sec.querySelector('[data-sy-color-boton]');
      var actual = 0;
      var activar = function (i) {
        if (i === actual) return;
        chips.forEach(function (ch, n) {
          ch.classList.toggle('is-activa', n === i);
          ch.setAttribute('aria-pressed', n === i ? 'true' : 'false');
        });
        fotos.forEach(function (f, n) {
          f.classList.toggle('is-previa', n === actual);
          f.classList.toggle('is-activa', n === i);
        });
        actual = i;
        var chip = chips[i];
        if (!chip) return;
        if (nombre) nombre.textContent = chip.dataset.nombre || '';
        if (boton && chip.dataset.url) boton.setAttribute('href', chip.dataset.url);
        if (chip.dataset.tinte) (sec.closest('.shopify-section') || sec).style.setProperty('--sy-col-tinte', chip.dataset.tinte);
      };
      chips.forEach(function (ch, i) { ch.addEventListener('click', function () { activar(i); }); });
    });
  }

  /* ---------- Producto ---------- */
  function dinero(centimos, formato) {
    var valor = (centimos / 100).toFixed(2);
    var partes = valor.split('.');
    var miles = function (s, sep) { return s.replace(/\B(?=(\d{3})+(?!\d))/g, sep); };
    return (formato || '{{amount_with_comma_separator}} €')
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, miles(partes[0], '.') + ',' + partes[1])
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, miles(String(Math.round(centimos / 100)), '.'))
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, miles(String(Math.round(centimos / 100)), ','))
      .replace(/\{\{\s*amount\s*\}\}/, miles(partes[0], ',') + '.' + partes[1])
      .replace(/<[^>]+>/g, '');
  }

  function initProducto(raiz) {
    raiz.querySelectorAll('[data-sy-producto]').forEach(function (sec) {
      if (sec.dataset.syListo) return;
      sec.dataset.syListo = '1';

      /* Galería */
      var principal = sec.querySelector('[data-sy-principal]');
      var minis = sec.querySelectorAll('.sy-prod__mini');
      var fotoBarra = sec.querySelector('[data-sy-barra-foto]');
      var mostrar = function (mini) {
        if (!principal || !mini) return;
        minis.forEach(function (m) { m.classList.toggle('is-activa', m === mini); });
        principal.classList.add('is-cambiando');
        setTimeout(function () {
          principal.removeAttribute('srcset');
          principal.src = mini.dataset.grande;
          principal.alt = mini.dataset.alt || '';
          principal.onload = function () { principal.classList.remove('is-cambiando'); };
          setTimeout(function () { principal.classList.remove('is-cambiando'); }, 600);
        }, 180);
        var miniImg = mini.querySelector('img');
        if (fotoBarra && miniImg) fotoBarra.src = miniImg.src;
      };
      minis.forEach(function (m) { m.addEventListener('click', function () { mostrar(m); }); });

      /* Cantidad */
      var cant = sec.querySelector('input[name="quantity"]');
      sec.querySelectorAll('.sy-cantidad button').forEach(function (b) {
        b.addEventListener('click', function () {
          var v = parseInt(cant.value, 10) || 1;
          v += b.dataset.paso === 'mas' ? 1 : -1;
          cant.value = Math.max(1, v);
          pintar();
        });
      });
      if (cant) cant.addEventListener('change', function () { pintar(); });

      var datos = sec.querySelector('[data-sy-variantes]');
      if (!datos) return;
      var info;
      try { info = JSON.parse(datos.textContent); } catch (e) { return; }
      var inputId = sec.querySelector('input[name="id"]');
      var boton = sec.querySelector('[data-sy-comprar]');
      var botonTexto = boton ? boton.querySelector('span') : null;
      var precio = sec.querySelector('[data-sy-precio]');
      var grupos = sec.querySelectorAll('.sy-prod__opcion');
      var packs = sec.querySelectorAll('.sy-packs input');
      var comps = Array.prototype.slice.call(sec.querySelectorAll('[data-sy-comp]'));
      var barra = sec.querySelector('[data-sy-barra]');
      var barraPrecio = sec.querySelector('[data-sy-barra-precio]');
      var barraBoton = sec.querySelector('[data-sy-barra-boton]');

      var varianteActual = function () {
        if (!grupos.length) return info.variantes.filter(function (v) { return String(v.id) === String(inputId.value); })[0] || info.variantes[0];
        var elegidas = [];
        grupos.forEach(function (g) {
          var marcado = g.querySelector('input:checked');
          elegidas.push(marcado ? marcado.value : null);
          var rot = g.querySelector('[data-sy-elegido]');
          if (rot && marcado) rot.textContent = marcado.dataset.visible || marcado.value;
        });
        return info.variantes.filter(function (v) {
          return v.options.every(function (o, i) { return o === elegidas[i]; });
        })[0];
      };

      function pintar(cambioDeVariante) {
        var variante = varianteActual();
        if (!variante) {
          if (boton) boton.setAttribute('disabled', 'disabled');
          if (botonTexto) botonTexto.textContent = info.textos.no_disponible;
          return;
        }
        if (inputId) inputId.value = variante.id;

        /* Packs: precio de cada fila y cantidad elegida */
        var totalElegido = null;
        packs.forEach(function (p) {
          var n = parseInt(p.dataset.cantidad, 10) || 1;
          var pct = parseFloat(p.dataset.descuento) || 0;
          var bruto = variante.price * n;
          var total = bruto - Math.ceil(bruto * pct / 100 - 0.5);
          var fila = p.nextElementSibling;
          var hueco = fila ? fila.querySelector('[data-sy-pack-precio]') : null;
          if (hueco) hueco.innerHTML = dinero(total, info.formato) + (pct > 0 ? '<s>' + dinero(bruto, info.formato) + '</s>' : '');
          if (p.checked) { totalElegido = total; if (cant) cant.value = n; }
        });
        if (totalElegido === null) totalElegido = variante.price * (cant ? (parseInt(cant.value, 10) || 1) : 1);

        /* Regalos: se desbloquean según las unidades elegidas */
        var unidades = cant ? (parseInt(cant.value, 10) || 1) : 1;
        comps.forEach(function (c) {
          var desde = parseInt(c.dataset.desde, 10) || 0;
          if (!desde) return;
          var fila = c.closest('.sy-comp__item');
          var libre = unidades >= desde;
          var estabaBloqueado = fila.classList.contains('is-bloqueado');
          fila.classList.toggle('is-bloqueado', !libre);
          c.checked = libre && !c.disabled;
          if (libre && estabaBloqueado) {
            fila.classList.remove('is-recien');
            void fila.offsetWidth;
            fila.classList.add('is-recien');
          }
        });

        /* Complementos marcados: se suman al total con su descuento */
        comps.forEach(function (c) {
          if (!c.checked) return;
          var pc = parseInt(c.dataset.precio, 10) || 0;
          totalElegido += pc - Math.round(pc * (info.comp_descuento || 0) / 100);
        });

        var textoBoton = variante.available ? info.textos.comprar : info.textos.agotado;
        if (variante.available && info.textos.con_total) textoBoton += ' · ' + dinero(totalElegido, info.formato);
        if (boton) {
          if (variante.available) boton.removeAttribute('disabled'); else boton.setAttribute('disabled', 'disabled');
          if (botonTexto) botonTexto.textContent = textoBoton;
        }
        if (barraBoton) {
          barraBoton.disabled = !variante.available;
          barraBoton.querySelector('span').textContent = variante.available ? info.textos.comprar : info.textos.agotado;
        }
        if (barraPrecio) barraPrecio.textContent = dinero(totalElegido, info.formato);

        if (precio) {
          var html = '<span>' + dinero(variante.price, info.formato) + '</span>';
          if (variante.compare_at_price && variante.compare_at_price > variante.price) {
            var pct2 = Math.round((1 - variante.price / variante.compare_at_price) * 100);
            html += '<s>' + dinero(variante.compare_at_price, info.formato) + '</s>';
            html += '<span class="sy-prod__ahorro">-' + pct2 + '%</span>';
          }
          precio.innerHTML = html;
        }

        if (cambioDeVariante) {
          if (variante.featured_media_id) {
            var mini = sec.querySelector('.sy-prod__mini[data-media="' + variante.featured_media_id + '"]');
            if (mini && !mini.classList.contains('is-activa')) mostrar(mini);
          }
          if (window.history && history.replaceState && !enEditor) {
            var url = new URL(window.location.href);
            url.searchParams.set('variant', variante.id);
            history.replaceState({}, '', url.toString());
          }
        }
      }

      grupos.forEach(function (g) {
        g.querySelectorAll('input').forEach(function (i) { i.addEventListener('change', function () { pintar(true); }); });
      });
      packs.forEach(function (p) { p.addEventListener('change', function () { pintar(false); }); });
      comps.forEach(function (c) { c.addEventListener('change', function () { pintar(false); }); });
      sec.querySelectorAll('[data-sy-comp-variante]').forEach(function (s) {
        s.addEventListener('change', function () {
          var c = document.getElementById(s.dataset.syCompVariante);
          if (!c) return;
          c.value = s.value;
          var op = s.options[s.selectedIndex];
          if (op && op.dataset.precio) c.dataset.precio = op.dataset.precio;
          pintar(false);
        });
      });

      /* Al comprar: primero se añaden regalos/complementos y luego sigue la compra normal */
      var compsAnadidos = false;
      sec.addEventListener('submit', function (ev) {
        if (!comps.length || compsAnadidos) { compsAnadidos = false; return; }
        ev.preventDefault();
        ev.stopImmediatePropagation();
        var formulario = ev.target;
        if (boton) { boton.setAttribute('aria-disabled', 'true'); boton.classList.add('loading'); }
        var seguir = function () {
          compsAnadidos = true;
          if (boton) { boton.removeAttribute('aria-disabled'); boton.classList.remove('loading'); }
          if (formulario.requestSubmit) formulario.requestSubmit(boton || undefined); else formulario.submit();
        };
        var base = (window.routes && window.routes.cart_url) || '/cart';
        var rutaAnadir = ((window.routes && window.routes.cart_add_url) || '/cart/add') + '.js';
        var anadiendo = cant ? (parseInt(cant.value, 10) || 1) : 1;
        fetch(base + '.js', { headers: { 'Accept': 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (carrito) {
            var yaHay = {}, unidadesEnCarrito = 0;
            (carrito.items || []).forEach(function (it) {
              yaHay[it.product_id] = true;
              if (String(it.product_id) === String(info.product_id)) unidadesEnCarrito += it.quantity;
            });
            var totalUnidades = unidadesEnCarrito + anadiendo;
            var items = [];
            comps.forEach(function (c) {
              if (c.disabled) return;
              var desde = parseInt(c.dataset.desde, 10) || 0;
              if (desde) {
                if (totalUnidades >= desde && !yaHay[c.dataset.producto]) items.push({ id: parseInt(c.value, 10), quantity: 1 });
              } else if (c.checked) {
                items.push({ id: parseInt(c.value, 10), quantity: 1 });
                c.checked = false;
              }
            });
            if (!items.length) return null;
            return fetch(rutaAnadir, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
              body: JSON.stringify({ items: items })
            });
          })
          .then(seguir)
          .catch(seguir);
      }, true);
      pintar(false);

      /* Barra de compra fija */
      if (barra && boton && 'IntersectionObserver' in window) {
        var zona = sec.querySelector('product-form') || boton;
        var pie = document.querySelector('.sy-footer');
        var zonaVisible = true, pieVisible = false;
        var decidir = function () {
          var pasada = zona.getBoundingClientRect().bottom < 0;
          barra.classList.toggle('is-visible', !zonaVisible && pasada && !pieVisible);
        };
        new IntersectionObserver(function (es) { zonaVisible = es[0].isIntersecting; decidir(); }).observe(zona);
        if (pie) new IntersectionObserver(function (es) { pieVisible = es[0].isIntersecting; decidir(); }).observe(pie);
        if (barraBoton) barraBoton.addEventListener('click', function () {
          if (boton.requestSubmit && boton.form) boton.form.requestSubmit(boton); else boton.click();
        });
      }
    });
  }

  /* ---------- Carrito: botón "mejorar mi pack" ---------- */
  document.addEventListener('click', function (ev) {
    var b = ev.target.closest ? ev.target.closest('[data-sy-mejorar]') : null;
    if (!b || b.getAttribute('aria-disabled') === 'true') return;
    ev.preventDefault();
    var items;
    try { items = JSON.parse(b.getAttribute('data-sy-mejorar')); } catch (e) { return; }
    b.setAttribute('aria-disabled', 'true');
    var cajon = document.querySelector('cart-drawer');
    var enPaginaCarrito = !!document.querySelector('cart-items') && !document.querySelector('cart-drawer-items');
    var cuerpo = { items: items };
    if (cajon && cajon.getSectionsToRender && !enPaginaCarrito) {
      cuerpo.sections = cajon.getSectionsToRender().map(function (s) { return s.id; });
      cuerpo.sections_url = window.location.pathname;
    }
    var ruta = ((window.routes && window.routes.cart_add_url) || '/cart/add') + '.js';
    fetch(ruta, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(cuerpo) })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (!res || res.status || !res.sections || !cajon || enPaginaCarrito) { window.location.reload(); return; }
        cajon.renderContents(res);
      })
      .catch(function () { window.location.reload(); });
  });

  function initTodo(raiz) {
    raiz = raiz || document;
    initTitulos(raiz);
    initComparadores(raiz);
    initCifras(raiz);
    initColores(raiz);
    initProducto(raiz);
    initInclinacion(raiz);
    initScroll(raiz);
    observar(Array.prototype.slice.call(raiz.querySelectorAll('.sy-reveal:not(.sy-visible), .sy-observa:not(.sy-visible)')));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initTodo(document); });
  } else {
    initTodo(document);
  }
  document.addEventListener('shopify:section:load', function (e) { initTodo(e.target); });
})();
